import { Dimensions, StyleSheet, Platform } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: keyboardHeight => ({
    marginTop: 25,
    paddingBottom: keyboardHeight,
  }),
  descriptionTextStyle: {
    fontSize: 24,
    lineHeight: 32,
    marginBottom: 33.33,
    fontFamily: Fonts.type.VodafoneLt,
  },
  priceInfoContainerStyle: {
    marginTop: 12.1,
    marginBottom: 32,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  priceInfoTitleTextStyle: {
    fontSize: 18,
    lineHeight: 25,
    marginTop: 3.5,
  },
  priceInfoSubtitleTextStyle: {
    fontSize: 14,
    lineHeight: 25,
    fontFamily: Fonts.type.VodafoneLt,
  },
  priceTextStyle: {
    fontSize: 24,
    lineHeight: 31.2,
    ...Fonts.type.bold,
  },
  vatTextStyle: {
    fontSize: 14,
    lineHeight: 14.6,
    fontFamily: Fonts.type.VodafoneLt,
    textAlign: 'right',
    marginTop: 3.4,
  },
  confirmButtonStyle: showCancelBtn => ({
    marginBottom: showCancelBtn ? 17.4 : -18,
  }),
  headerStyle: {
    marginTop: 5,
    marginHorizontal: 0,
    alignItems: 'center',
  },
  hintTextStyle: {
    fontSize: 16,
    lineHeight: 20,
  },
  hintStyle: withSecondHint => ({
    marginBottom: withSecondHint ? 16.67 : 32,
  }),
  secondHintStyle: {
    marginBottom: 32,
  },
  secondaryButton: {
    marginBottom: Dimensions.get('screen').height < 800 ? -10 : 0,
  },
  buttonsContainerStyle: {
    marginBottom: Platform.OS === 'android' ? 20 : 0,
  },
});
